module.exports = __webpack_public_path__ + "static/media/freeRoundsBannerDefault.7286f776.png";